import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import { readConfig } from './core/config.ts';
import { App } from './app/App.tsx';
import { createCloudServices, type Services } from './core/services.tsx';
import { createDemoServices } from './demo/demoServices.ts';

function ConfigError({ problems }: { problems: string[] }) {
  return (
    <main className="content" style={{ maxWidth: 640, margin: '10vh auto' }}>
      <div className="state-box state-error" role="alert">
        <h1>Falta configuración</h1>
        <p>La interfaz no puede conectarse a la nube porque faltan variables públicas de compilación:</p>
        <ul style={{ textAlign: 'left' }}>{problems.map((p) => <li key={p}>{p}</li>)}</ul>
        <p>Consulta docs/despliegue.md. Para probar sin nube, compila con VITE_APP_MODE=demo (datos simulados).</p>
      </div>
    </main>
  );
}

const { config, problems } = readConfig();
const root = createRoot(document.getElementById('root')!);
function demoFlag(): boolean {
  if (import.meta.env.VITE_APP_MODE === 'demo') return true;
  const q = new URLSearchParams(window.location.search).get('demo');
  try {
    if (q === '0') sessionStorage.removeItem('estudio.demo');
    return q === '1' || sessionStorage.getItem('estudio.demo') === '1';
  } catch {
    return q === '1';
  }
}
const demoRequested = demoFlag();

if (!config && !demoRequested) {
  root.render(<ConfigError problems={problems} />);
} else {
  const services: Services = demoRequested || !config ? createDemoServices() : createCloudServices(config);
  root.render(
    <StrictMode>
      <App services={services} />
    </StrictMode>,
  );
}
